import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search, HelpCircle, Mail } from "lucide-react";
import "./NotFound.css";

const NotFound = () => {
  return (
    <main className="not-found-page">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="error-visual">
            <div className="error-number">404</div>
            <div className="error-illustration">
              <div className="floating-elements">
                <div className="element element-1"></div>
                <div className="element element-2"></div>
                <div className="element element-3"></div>
              </div>
            </div>
          </div>

          <div className="error-text">
            <h1 className="error-title">Page Not Found</h1>
            <p className="error-description">
              Oops! The page you're looking for seems to have wandered off.
              Don't worry, even the best explorers sometimes take a wrong turn.
            </p>
          </div>

          <div className="error-actions">
            <Link to="/" className="btn btn-primary">
              <Home size={18} />
              Back to Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="btn btn-secondary"
            >
              <ArrowLeft size={18} />
              Go Back
            </button>
          </div>

          <div className="help-section">
            <h3>Need Help?</h3>
            <div className="help-options">
              <Link to="/" className="help-option">
                <Search size={20} />
                <span>Search our site</span>
              </Link>
              <Link to="/about" className="help-option">
                <HelpCircle size={20} />
                <span>Visit Help Center</span>
              </Link>
              <Link to="/contact" className="help-option">
                <Mail size={20} />
                <span>Contact Support</span>
              </Link>
            </div>
          </div>
        </div>

        <div className="popular-pages">
          <h4>Popular Pages</h4>
          <div className="page-links">
            <Link to="/" className="page-link">
              <span>Home</span>
              <span className="page-description">
                Start your learning journey
              </span>
            </Link>
            <Link to="/about" className="page-link">
              <span>About Us</span>
              <span className="page-description">Learn about our mission</span>
            </Link>
            <Link to="/contact" className="page-link">
              <span>Contact</span>
              <span className="page-description">Get in touch with us</span>
            </Link>
            <Link to="/login" className="page-link">
              <span>Login</span>
              <span className="page-description">Access your account</span>
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
